import triggerTracking from '@blueprint/tracking';

export const Navigation = [
    {
        href: '/for-sale/',
        title: 'For sale'
    },
    {
        href: '/to-rent/',
        title: 'To rent'
    },
    {
        href: '/house-prices/',
        title: 'House prices'
    },
    {
        href: '/valuation/',
        title: 'Agent valuation'
    },
    {
        href: '/home-values/',
        title: 'Instant valuation'
    }
];

export const trackAccount = (label?: string) => () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'User Account',
        eventAction: 'clickthrough',
        eventLabel:
            label === 'my home'
                ? 'my home'
                : label
                ? `user account>${label}`
                : 'user account'
    });
};

export const trackNav = (label: string) => () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'navbar',
        eventAction: 'clickthrough',
        eventLabel: label.toLowerCase()
    });
};

export const getSigninUrl = (path: string) => {
    const encodedUrl = encodeURIComponent(path);

    return path.includes('/signin/')
        ? '/signin/?with_confirmation=true'
        : `/signin/?page_after_login=${encodedUrl}&return_url=${encodedUrl}&with_confirmation=true`;
};
